import { createFileRoute } from "@tanstack/react-router";
import DryFreight from "@/pages/services/DryFreight";

export const Route = createFileRoute("/services/dry-freight")({ component: DryFreight });